import React from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import EditEmployeeMainComp from "../../components/body/editcomponent/editemployee/editemployeemaincomp";

const EditEmployeeScreen=()=>{
    return(
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <EditEmployeeMainComp />
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default EditEmployeeScreen;